import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b1f153f4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "QuestionTplViewContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft18"
}, "套题管理", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "套题列表", -1));
const _hoisted_4 = {
  style: {
    "height": "400px",
    "overflow-y": "scroll"
  }
};
const _hoisted_5 = {
  class: "vpd16 box"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ml32 ft14 ptr",
  style: {
    "color": "#015EF5"
  }
}, "收入历史套题", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "lightcoral"
  },
  class: "ft12 ptr"
}, "删除分组", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_LeftGroupList = _resolveComponent("LeftGroupList");
  const _component_ButtonDialog = _resolveComponent("ButtonDialog");
  const _component_el_collapse_item = _resolveComponent("el-collapse-item");
  const _component_el_collapse = _resolveComponent("el-collapse");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_popconfirm = _resolveComponent("el-popconfirm");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_BatterTableDataView = _resolveComponent("BatterTableDataView");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_row, {
    class: "mt12"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 4,
      class: "wbg flex flex-col wd100"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        class: "pd12"
      }, {
        default: _withCtx(() => [_hoisted_3]),
        _: 1
      }), _createVNode(_component_el_divider, {
        style: {
          "margin": "0"
        }
      }), _createElementVNode("div", _hoisted_4, [_createVNode(_component_LeftGroupList, {
        data: $data.groups,
        onChoose: $options.onChoose
      }, null, 8, ["data", "onChoose"])]), _createVNode(_component_el_row, {
        class: "pd12"
      }, {
        default: _withCtx(() => [_createVNode(_component_ButtonDialog, {
          "btn-id": 7,
          "btn-name": "+ 新增分组",
          style: 1,
          size: "small",
          onFresh: $options.init
        }, null, 8, ["onFresh"])]),
        _: 1
      }), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_collapse, null, {
        default: _withCtx(() => [_createVNode(_component_el_collapse_item, {
          title: "   历史套题",
          name: "1"
        }, {
          default: _withCtx(() => [_createVNode(_component_LeftGroupList, {
            data: $data.historyGroups,
            onChoose: $options.onChoose
          }, null, 8, ["data", "onChoose"])]),
          _: 1
        })]),
        _: 1
      })])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 20,
      class: "opd12 flex flex-col"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        class: "pd12 wbg flex items-center"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 20,
          class: "flex items-center"
        }, {
          default: _withCtx(() => [$data.groupId > 0 ? (_openBlock(), _createBlock(_component_ButtonDialog, {
            key: 0,
            "btn-id": 8,
            "init-data": {
              'groupId': $data.groupId
            },
            "btn-name": "添加套题",
            onFresh: _cache[0] || (_cache[0] = $event => _ctx.$refs.tplTable.fetchData())
          }, null, 8, ["init-data"])) : _createCommentVNode("", true), $data.groupId > 0 ? (_openBlock(), _createBlock(_component_el_popconfirm, {
            key: 1,
            title: "确定移入历史吗",
            onConfirm: _cache[1] || (_cache[1] = $event => $options.markAsHistory($data.groupId))
          }, {
            reference: _withCtx(() => [_hoisted_6]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 4,
          class: "flex justify-end items-center"
        }, {
          default: _withCtx(() => [$data.groupId != null && $data.groupId > 0 ? (_openBlock(), _createBlock(_component_el_popconfirm, {
            key: 0,
            title: "确定删除吗",
            onConfirm: $options.deleteTplGroup
          }, {
            reference: _withCtx(() => [_hoisted_7]),
            _: 1
          }, 8, ["onConfirm"])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "pd12 wbg"
      }, {
        default: _withCtx(() => [_createVNode(_component_BatterTableDataView, {
          "table-id": 2,
          onOnDetailData: $options.onDetailData,
          "init-query": {
            'groupId': $data.groupId
          },
          ref: "tplTable"
        }, {
          subject: _withCtx(data => [_createElementVNode("span", null, _toDisplayString(data.mapping[data.rowData]), 1)]),
          secondTimeLimit: _withCtx(data => [_createElementVNode("span", null, _toDisplayString(data.rowData / 60), 1)]),
          randomPractice: _withCtx(data => [_createVNode(_component_el_switch, {
            "model-value": data.rowData,
            onClick: $event => $options.updateRandomPractice(data.rowId)
          }, null, 8, ["model-value", "onClick"])]),
          _: 1
        }, 8, ["onOnDetailData", "init-query"])]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })]);
}